import Page500 from './Page500';

export default Page500;
